"use strict";

import Mongo from "./mongo.collection";

if (typeof globalThis !== "undefined") {
    globalThis.Mongo = Mongo;
}

export { Mongo };
